export const adjustPlayersOWS = (players) => {
  return players.map(p => {
    p.HouseProjPts = p.ProjPts
    p.JMProjPts = Number(p.ProjPts) === 0 ? 0 : (Number(p.Salary) / 1000 * 4).toFixed(2)
    
    return p
  })
}